// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"card_XUalX","logo":"logo_8w3yH"};